module.exports = __webpack_public_path__ + "static/mehmetcik-web-31e5f6db89715ae0d843e67c26c3d253.jpg";